import { Api } from '@axiom/ui';
import type { Account, AccountMeetingLinkTypes } from '@axiom/validation';
import { AccountConst } from '@axiom/const';

import { EnvUtil } from '../utils/env-util';
import LegacyApiHelper from '../classes/legacy-api-helper';

const api = new LegacyApiHelper('barred location');

export const getAccount = async (accountId: Account['id']) => {
  const { data: account } = await api.GET(
    `${EnvUtil.apiEnvoyUrl}/accounts/${accountId}`
  );
  return account;
};

export const getAccounts = async (filterMeta: {
  search: string;
  page: number;
}) => {
  const { data, meta } = await api.GET(
    `${EnvUtil.apiEnvoyUrl}/accounts`,
    filterMeta,
    true
  );
  return {
    results: data,
    meta,
  };
};

class AccountsApiClass extends Api {
  constructor() {
    super({
      domain: EnvUtil.apiEnvoyUrl,
    });
  }

  readAccount(accountId: Account['id']) {
    return super.read<{ data: Account }>({
      endpoint: `/accounts/${accountId}`,
      query: {
        expand: [AccountConst.Expansions.parentAccountInfo],
      },
      method: 'GET',
    });
  }

  async invalidateAccount(accountId: Account['id']) {
    return super.invalidate(`/accounts/${accountId}`);
  }

  readMeetingLinkTypes(accountId: Account['id']) {
    return super.read<{ data: AccountMeetingLinkTypes }>({
      endpoint: `/accounts/${accountId}/meetingLinkTypes`,
      method: 'GET',
    });
  }

  readAccounts(filterMeta: { search: string; page: number }) {
    return super.read<{
      data: Account[];
      meta: { currentPage: number; pageCount: number; resultCount: number };
    }>({
      endpoint: `/accounts`,
      query: filterMeta,
      method: 'GET',
    });
  }

  async invalidateAccounts() {
    return super.invalidate(`/accounts`);
  }

  async updateAccount(accountId: Account['id'], body: Partial<Account>) {
    return super.write<{ data: Account }>({
      endpoint: `/accounts/${accountId}`,
      body,
      method: 'PATCH',
    });
  }
}

export const AccountsApi = new AccountsApiClass();
